import { render } from "./ActivationLog.vue?vue&type=template&id=647750ae&scoped=true&ts=true"
import script from "./ActivationLog.vue?vue&type=script&lang=ts"
export * from "./ActivationLog.vue?vue&type=script&lang=ts"

import "./ActivationLog.vue?vue&type=style&index=0&id=647750ae&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647750ae"]])

export default __exports__